module.exports = __webpack_public_path__ + "img/bg-proyectos-3.c6853bfa.png";